<!--
  IMPORTANT: We don't need to translate the content since this page will only
  be shown when loading https://www.bilbayt.com without selecting the country
  or language
-->

<ion-content>
  <div class="section header-image">
    <div class="section-content header-image-content">
      <div class="header-image-start">
        <p class="header-title">Bilbayt</p>
        <p class="header-description">
          Order from hundreds of curated sellers your daily Groceries, Food, Flowers, Catering, Rentals, and Kid's Activities from a single
          app well known for its legendary customer service.
        </p>
      </div>
      <div class="header-image-end">
        <p class="title">Select Country</p>
        <div class="countries">
          <div tappable class="country" *ngFor="let country of availableCountries" (click)="onCountryChange(country)">
            <div class="country-flag" [style.backgroundImage]="'url(' + country.flagUrl + ')'"></div>
            <div class="country-name">{{ country.name | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section for-business">
    <div class="section-content for-business-content">
      <p class="section-title">Bilbayt for Business</p>
      <div class="for-business-items">
        <div class="for-business-item">
          <div class="for-business-item-icon dedicacted-account-manager"></div>
          <p class="for-business-item-title">Save Time</p>
          <p class="for-business-item-description">
            Tell us what you need and we’ll prepare customized menus and quotes from multiple vendors.
          </p>
        </div>
        <div class="for-business-item">
          <div class="for-business-item-icon custom-menus"></div>
          <p class="for-business-item-title">Impress Clients</p>
          <p class="for-business-item-description">
            We only work with caterers that deliver outstanding reliability, food quality, and presentation.
          </p>
        </div>
        <div class="for-business-item">
          <div class="for-business-item-icon flexible-payment-options"></div>
          <p class="for-business-item-title">Flexible Payment</p>
          <p class="for-business-item-description">
            Easily pay online with credit or debit cards, cash on delivery, cheques, or bank transfers.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="section trusted-by">
    <div class="section-content trusted-by-content">
      <p class="section-title">Trusted By</p>
      <img class="trusted-by-item-image" src="https://cdn.bilbayt.com/assets/managed-company-logos-636603314813570704.png" />
    </div>
  </div>

  <app-browser-footer></app-browser-footer>
</ion-content>
